import React, { useState } from "react";
import Button from "../../../../reusable-components/buttons/Button";
import TableWrapper from "../../../../reusable-components/table/TableWrapper";
import { linkTextPrimary } from "../../../../theme/lightTheme";

import { OCCASION_TYPE_CONFIG_URL } from "../../../../api/api_routing_urls";
import axios from "../../../../api/axios";
import DeleteModal from "../../../../reusable-components/modals/DeleteModal";
import showToast from "../../../../utilities/notification/NotificationModal";
import { linkTextDanger } from "../../../../theme/lightTheme";

export default function OccasionTypeList({
  occasionTypeList,
  getOccasionTypeList,
  setEditOccasionTypeDetails,
  setShowAddForm,
}) {
  const onClickEdit = (occasionType) => {
    setEditOccasionTypeDetails(occasionType);
    setShowAddForm(true);
  };

  const [showDelete, setShowDelete] = useState(false);
  const [occasionTypeDeleteId, setOccasionTypeDeleteId] = useState(null);

  const onClickDelete = async () => {
    // console.log("Received ID to delete: ", occasionTypeDeleteId);
    try {
      let response = "";
      if (occasionTypeDeleteId) {
        response = await axios.post(`${OCCASION_TYPE_CONFIG_URL}/delete`, {
          occasion_type_id: occasionTypeDeleteId,
        });
        setShowDelete(false);
      }

      if (response.status === 200) {
        showToast(
          "Occasion Type details has been deleted successfully.",
          "success"
        );
        getOccasionTypeList();
      } else {
        showToast("Occasion Type details deletion failed.", "error");
      }
    } catch (error) {
      console.log("Delete Module Error", error);
    } finally {
      setOccasionTypeDeleteId(null);
    }
  };

  return (
    <TableWrapper>
      <thead className="bg-white text-sm">
        <tr>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Sl No.
          </th>
          <th
            scope="col"
            className="px-6 py-3 text-left font-medium text-gray-900 uppercase tracking-wider"
          >
            Occasion Type Name
          </th>
          <th
            scope="col"
            className="pl-6 pr-9 py-3 text-right font-medium text-gray-900 uppercase tracking-wider"
          >
            Actions
          </th>
        </tr>
      </thead>
      <tbody className="bg-white divide-y divide-gray-100 text-gray-600">
        {occasionTypeList?.length > 0 &&
          occasionTypeList?.map((occasionType, index) => (
            <tr key={index}>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {index+1}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                {occasionType.occasion_type_name}
              </td>
              <td className="px-6 py-4 whitespace-nowrap text-sm">
                <div className="flex justify-end">
                  <Button
                    onClick={() => onClickEdit(occasionType)}
                    aria-label="Edit Occasion Type Details"
                    className={linkTextPrimary}
                  >
                    Edit
                  </Button>
                  <Button
                    onClick={() => {
                      setOccasionTypeDeleteId(
                        occasionType?.occasion_type_id || null
                      );
                      setShowDelete(true);
                    }}
                    aria-label="Delete Occasion Type Details"
                    className={linkTextDanger}
                  >
                    Delete
                  </Button>
                </div>
              </td>
            </tr>
          ))}
      </tbody>

      <>
        <DeleteModal
          open={showDelete}
          setOpen={setShowDelete}
          message={"This entry will be deleted. Are you sure?"}
          onDelete={onClickDelete}
        />
      </>
    </TableWrapper>
  );
}
